import { render, staticRenderFns } from "./ResponseModal.vue?vue&type=template&id=170cf224&scoped=true"
import script from "./ResponseModal.vue?vue&type=script&lang=ts"
export * from "./ResponseModal.vue?vue&type=script&lang=ts"
import style0 from "./ResponseModal.vue?vue&type=style&index=0&id=170cf224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170cf224",
  null
  
)

export default component.exports